'use client';
import React from 'react';
import { ShareButtons } from '@benzinga/ui';
import { EdgeBadge } from '@benzinga/core-ui';
import UpdatedBadge from '../../reports/components/UpdatedBadge';
import styles from './MarketUpdateHeader.module.css';

const MARKET_UPDATE_DESCRIPTION =
  'Get the market overview with key economic events, company earnings, analyst ratings, and pre-market indexes.';

export const MarketUpdateHeader = () => {
  return (
    <div className={styles.headerWrap}>
      <div className="block-content-wrapper">
        <div className="content-top">
          <div className="w-full text-white mt-5">
            <div className={styles.headerTopRow}>
              <div className="text-left max-w-2xl">
                <h2 className="block-title text-white flex items-center gap-5 flex-wrap">
                  Market Update
                  <span className="scale-125">{EdgeBadge}</span>
                </h2>
                <p className={styles.description}>{MARKET_UPDATE_DESCRIPTION}</p>
              </div>

              <UpdatedBadge date={Date.now()} />
            </div>
          </div>
        </div>
        <div className={styles.contentBottom}>
          <div className={styles.headerActions}>
            <ShareButtons
              buttonLocation="market_update_page"
              showButtons={['linkedin', 'twitter', 'facebook', 'bluesky']}
              title="Market Update"
              url="https://www.benzinga.com/market-update"
              buttonStyle={{ borderRadius: 4 as number }}
            />
            <ShareButtons
              buttonLocation="market_update_page"
              showButtons={['email', 'copy']}
              title="Market Update"
              url="https://www.benzinga.com/market-update"
              buttonStyle={{
                borderRadius: 4 as number,
                bgStyle: { fill: '#17315d' } as React.CSSProperties,
                iconFillColor: '#3F83F8',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
